import { useContext } from 'react';

import { InputContext } from 'src/contexts/input.context';
import { ParserContext } from 'src/contexts/parser.context';
import { InlineInput } from 'src/components/Inputs';
import { usePhoneInput } from 'src/hooks/usePhoneInput';
import { mockFn } from 'src/tools/fn.tools';
import { stringToPhone } from 'src/tools/string.tools';
import { ifTrue } from 'src/tools/logic.tools';
import { UseIcon } from 'src/components/UseIcon';
import { P2 } from 'src/components/Typography';
import clsx from 'clsx';

export function InlinePhone() {
  const { classNames, onDiscard, isDisabled, isAutoFocus, onClick, isReadonly, value } = useContext(InputContext);

  const spreadsheetContext = useContext(ParserContext);

  const { displayValue, handleOnSubmit, handleOnChange, handleOnKeyDown } = usePhoneInput();

  const isReadonlyProp = isReadonly ?? !spreadsheetContext.isActive;

  const valueProp = value ?? spreadsheetContext.value;

  const classNamesProps = classNames?.input ?? spreadsheetContext.classNames?.input;

  function renderInput() {
    return (
      <InlineInput
        className={classNamesProps}
        value={stringToPhone(displayValue)}
        onChange={handleOnChange}
        onClick={onClick ?? spreadsheetContext.onClick}
        onKeyDown={handleOnKeyDown}
        isDisabled={isDisabled}
        isReadonly={isReadonlyProp}
        autoFocus={isAutoFocus}
        onDiscard={onDiscard ?? spreadsheetContext.onDiscard ?? mockFn}
        onSubmit={handleOnSubmit}
      />
    );
  }

  function renderLink() {
    return (
      <div className='row items-p8 a-center w-100p o-hidden'>
        <P2
          className={clsx('t-ellipsis', spreadsheetContext.script?.isEditable ? 'c-pointer' : 'c-default')}
          title={displayValue}
          onClick={onClick ?? spreadsheetContext.onClick}
        >
          {displayValue}
        </P2>
        <a href={`tel:${valueProp}`} target='_blank' rel='noopener noreferrer'>
          <UseIcon className='default-icon' iconId='phone' />
        </a>
      </div>
    );
  }

  return ifTrue(isReadonlyProp && valueProp, renderLink, renderInput);
}
